/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/CheckCircle';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const CheckCircleIcon = withMuiAdapter(Base, 'CheckCircle');
